
const Loader = () => {
  return <div className="spinner-container">
    <div className="spinner" aria-hidden="true"></div>
    <div className="c51qp4do9v5lk8" aria-live="polite" aria-atomic="true"></div>
  </div>
}

export default Loader;
